module.exports = __webpack_public_path__ + "img/大数据图形.f55537eb.png";